
const getters = {
  getEvents: state => state.events,
  getSale: state => state.sale,
  getTours: state => state.tours,
}

export default getters